export const resolveFeaturedImage = (post) => {
    if (post.featured_image_url) {
        return post.featured_image_url;
    }

    if (post.image_url) {
        return post.image_url;
    }

    if (post.image) {
        return `../images/${post.image}`;
    }

    return '';
};

export const getPublishedDateValue = (post) => (
    post.published_at ||
    post.date_created ||
    null
);

export const getPublishedDate = (post) => {
    const value = getPublishedDateValue(post);

    if (!value) {
        return null;
    }

    if (typeof value?.toDate === 'function') {
        return value.toDate();
    }

    const parsedDate = value instanceof Date ? value : new Date(value);

    return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
};
